import { CircleCheck, CircleDot, CircleMinus, CircleX } from 'lucide-react';

import { buildAnalyticsEventName, trackAnalyticsEvent } from '@/lib/analytics';
import { classNames } from '@/utils/classNames';

import styles from '@/styles/positions.module.css';

type AnswerOptionProps = {
  label: string;
  selected: boolean;
  onSelect: () => void;
  analyticsScope?: string;
  value?: -2 | -1 | 0 | 1 | 2 | 'disagree' | 'partiallyDisagree' | 'neutral' | 'partiallyAgree' | 'agree';
};

const optionIcons: Record<NonNullable<AnswerOptionProps['value']>, JSX.Element> = {
  [-2]: <CircleX size={18} />,
  [-1]: <CircleMinus size={18} />,
  0: <CircleDot size={18} />,
  1: <CircleCheck size={18} />,
  2: <CircleCheck size={18} />,
  disagree: <CircleX size={18} />,
  partiallyDisagree: <CircleMinus size={18} />,
  neutral: <CircleDot size={18} />,
  partiallyAgree: <CircleCheck size={18} />,
  agree: <CircleCheck size={18} />,
};

export function AnswerOption({ label, selected, onSelect, analyticsScope, value }: AnswerOptionProps): JSX.Element {
  return (
    <button
      type="button"
      className={classNames(styles.answerButton, selected && styles.answerButtonActive)}
      onClick={() => {
        trackAnalyticsEvent(buildAnalyticsEventName(label, analyticsScope ?? label));
        onSelect();
      }}
      aria-pressed={selected}
    >
      <span className={classNames(styles.answerIcon, selected && styles.answerIconActive)} aria-hidden="true">
        {optionIcons[value ?? 0]}
      </span>
      <span className={styles.answerLabel}>{label}</span>
    </button>
  );
}
